import createReactComponent from '../createReactComponent';
var Umbrella = createReactComponent('Umbrella', [['path', {
  d: 'M23 12a11.05 11.05 0 00-22 0zm-5 7a3 3 0 01-6 0v-7',
  key: '158w0t'
}]]);
export default Umbrella;